export default {
  colors: {
    background: `#FCFCFF`,
    headerBg: `transparent`,
    footerBg: `#F6F7FA`
  }
}
